import { render, staticRenderFns } from "./FilterWalletFiltered.vue?vue&type=template&id=4dfb3044"
import script from "./FilterWalletFiltered.vue?vue&type=script&lang=ts"
export * from "./FilterWalletFiltered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports